(function(){
"use strict";
/* ═════ I18N: motor metin taşımaz ═════
   Treść: window.LBQ_CONTENT[locale] = { "klucz": "tekst", ... }
   Łańcuch zapasowy: bieżący język → en → pl. Brak klucza nigdy nie psuje strony. */
var LBQ_LOC=(function(){
  var l=(window.LBQ_LOCALE||document.documentElement.lang||'pl').toLowerCase().slice(0,2);
  return l;
})();
function T(k){
  var C=window.LBQ_CONTENT||{};
  if(!C.pl&&!C.en&&!T._f){T._f=1;
    try{document.getElementById('lbqStage').innerHTML=
      '<p style="font-size:15px">Narzędzie chwilowo niedostępne. Odśwież stronę lub napisz na '
      +'<a href="mailto:kontakt@labalancia.com">kontakt@labalancia.com</a>.</p>'}catch(e){}}
  var a=C[LBQ_LOC], b=C.en, c=C.pl;
  if(a&&a[k]!=null)return a[k];
  if(b&&b[k]!=null)return b[k];
  if(c&&c[k]!=null)return c[k];
  if(window.console&&!T._w){T._w=1;console.warn('[LBQ] brak treści dla języka '+LBQ_LOC)}
  return '';
}


var stage=document.getElementById('lbqStage'),
    rstage=document.getElementById('lbqResultStage'),
    consentBox=document.getElementById('lbqConsent'),
    V={intro:document.getElementById('lbqIntro'),
       quiz:document.getElementById('lbqQuiz'),
       result:document.getElementById('lbqResult'),
       calc:document.getElementById('lbqCalc')},
    view='intro';

/* ═════ ROUTER: trzy osobne ekrany, trzy adresy ═════ */
function go(v,push){
  if(view===v)return;
  Object.keys(V).forEach(function(k){V[k].hidden=(k!==v)});
  view=v;
  var el=V[v];el.classList.remove('swap-in');void el.offsetWidth;el.classList.add('swap-in');
  window.scrollTo({top:0,behavior:'instant' in window?'instant':'auto'});
  if(push!==false){
    var q=v==='quiz'?'?krok=1':(v==='result'?'?wynik=1':(v==='calc'?'?kalkulator=1':location.pathname));
    try{history.pushState({v:v},'',v==='intro'?location.pathname:q)}catch(e){}
  }
  track('lbq_view',{lbq_view:v});
}
window.addEventListener('popstate',function(e){
  /* Ekran adresten türetilir. Zwykła nawigacja do '#' nie może zresetować widoku. */
  var v=(e.state&&e.state.v);
  if(!v){
    var q=location.search;
    v = q.indexOf('krok=')>-1 ? 'quiz'
      : q.indexOf('wynik=')>-1 ? 'result'
      : q.indexOf('kalkulator=')>-1 ? 'calc' : 'intro';
  }
  if(!V[v]||view===v)return;
  Object.keys(V).forEach(function(k){V[k].hidden=(k!==v)});
  view=v;
});
var calcReady=false;
function openCalc(){
  go('calc');
  if(!calcReady){document.getElementById('lbqCalcStage').innerHTML=kalk('s',false);bindKalk('s');calcReady=true}
}
function bindHome(){
  document.querySelectorAll('#lbq [data-home]').forEach(function(el){
    el.onclick=function(ev){ev.preventDefault();go('intro')}});
}

/* ═════ REVEAL ═════ */
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(en){
    en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})
  },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('#lbq .rv').forEach(function(el,i){
    el.style.transitionDelay=(Math.min(i,4)*45)+'ms';io.observe(el)});
} else document.querySelectorAll('#lbq .rv').forEach(function(el){el.classList.add('in')});

/* ═════ ZGODA ═════ */
var KEY='lbq.p.v5',CKEY='lbq.consent',IDKEY='lbq.id',HKEY='lbq.hist',memory=false,decided=false;
function lsG(k){try{return localStorage.getItem(k)}catch(e){return null}}
function lsS(k,v){try{localStorage.setItem(k,v)}catch(e){}}
function lsD(k){try{localStorage.removeItem(k)}catch(e){}}
function ckS(n,v,d){try{var t=new Date();t.setTime(t.getTime()+d*864e5);
  document.cookie=n+'='+encodeURIComponent(v)+';expires='+t.toUTCString()+';path=/;SameSite=Lax'}catch(e){}}
function ckG(n){var m=document.cookie.match('(^|;)\\s*'+n+'\\s*=\\s*([^;]+)');return m?decodeURIComponent(m[2]):null}
function ckD(n){document.cookie=n+'=;Max-Age=0;path=/'}
function rid(){return 'lb'+Math.random().toString(36).slice(2,10)+Date.now().toString(36).slice(-4)}
function shopConsent(){try{if(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed)
  return Shopify.customerPrivacy.analyticsProcessingAllowed()}catch(e){}return null}
function initConsent(){
  var sc=shopConsent(),sv=lsG(CKEY);
  if(sv==='yes'){memory=true;decided=true}else if(sv==='no'){decided=true}
  else if(sc===true){memory=true;decided=true;lsS(CKEY,'yes')}else if(sc===false){decided=true}
  if(memory&&!ckG(IDKEY))ckS(IDKEY,rid(),180);
  if(!decided)cbar();
}
function cbar(){
  consentBox.innerHTML='<div class="glass cbar"><p>'+T('ui.112')+''
   +T('ui.121')
   +'<a href="'+shopPath('/policies/privacy-policy')+'" target="_blank" rel="noopener">'+T('ui.065')+'</a></p>'
   +'<button class="y" id="lbqCy">'+T('ui.066')+'</button><button id="lbqCn">'+T('ui.067')+'</button></div>';
  document.getElementById('lbqCy').onclick=function(){memory=true;decided=true;lsS(CKEY,'yes');
    if(!ckG(IDKEY))ckS(IDKEY,rid(),180);save();consentBox.innerHTML=''};
  document.getElementById('lbqCn').onclick=function(){memory=false;decided=true;lsS(CKEY,'no');
    lsD(KEY);ckD(IDKEY);consentBox.innerHTML=''};
}

/* ═════ PROFIL ═════ */
var P={id:null,v:5,path:null,a:{},tags:[],etap:null,customer:null,ctx:{},
       t:{start:null,perQ:{},total:0},calc:null,done:false};
function ctxRead(){
  var u=new URLSearchParams(location.search),c={};
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid']
   .forEach(function(k){if(u.get(k))c[k]=u.get(k)});
  /* własna domena jako źródło to szum — ruch wewnętrzny nie jest źródłem */
  c.ref='direct';
  try{ var r=document.referrer;
       if(r){ var h=new URL(r).hostname.replace(/^www\./,'');
              var me=location.hostname.replace(/^www\./,'');
              c.ref = (h===me) ? 'direct' : h; } }catch(e){}
  try{c.tz=Intl.DateTimeFormat().resolvedOptions().timeZone}catch(e){}
  c.device=window.innerWidth<900?'mobile':'desktop';
  try{if(window.Shopify){if(Shopify.country)c.rynek=Shopify.country;
    if(Shopify.locale)c.jezyk=Shopify.locale;
    if(Shopify.currency&&Shopify.currency.active)c.waluta=Shopify.currency.active}}catch(e){}
  return c;
}
function save(){if(memory){P.id=P.id||ckG(IDKEY)||rid();lsS(KEY,JSON.stringify(P))}}
function load(){if(!memory)return null;try{var r=lsG(KEY);return r?JSON.parse(r):null}catch(e){return null}}
function hist(){if(!memory)return[];try{return JSON.parse(lsG(HKEY)||'[]')}catch(e){return[]}}
function pushHist(){
  if(!memory||P.path!=='prospekt')return;
  var h=hist();
  if(h.length&&h[h.length-1].e===P.etap){h[h.length-1].d=Date.now()}  /* ten sam etap → aktualizuj, nie dubluj */
  else h.push({d:Date.now(),e:P.etap});
  lsS(HKEY,JSON.stringify(h.slice(-6)));
}
function track(n,d){
  try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:n},d||{}))}catch(e){}
  /* Reklamy: Meta Pixel i GA4 potrzebują zdarzenia konwersji do optymalizacji */
  try{
    if(typeof window.fbq==='function'){
      if(n==='lbq_start')fbq('trackCustom','DiagnosticStart',d||{});
      else if(n==='lbq_complete')fbq('trackCustom','DiagnosticComplete',d||{});
      else if(n==='lbq_lead')fbq('track','Lead',d||{});
    }
    if(typeof window.gtag==='function'){
      if(n==='lbq_lead')gtag('event','generate_lead',d||{});
      else gtag('event',n,d||{});
    }
  }catch(e){}
}
function shopPath(p){var l='';try{if(window.Shopify&&Shopify.routes&&Shopify.routes.root)l=Shopify.routes.root.replace(/\/$/,'')}catch(e){}return l+p}

/* ═════ PRODUKTY ═════ */
/* Liquid wstrzykuje LBQ_ROOT = korzeń bieżącego języka ('' albo '/de') */
var SHOP_ABS=(typeof window.LBQ_ROOT==='string')?window.LBQ_ROOT.replace(/\/+$/,''):'https://labalancia.com';
function isLocal(){return typeof window.LBQ_ROOT!=='string'&&location.protocol!=='http:'&&location.protocol!=='https:'}
function jget(url){
  return fetch(url,{headers:{'Accept':'application/json'}})
    .then(function(r){return r.ok?r.json():null}).catch(function(){return null});
}
function mapProducts(d){
  if(!d||!d.products)return [];
  return d.products.map(function(p){
    var im=(p.images&&p.images[0])?p.images[0].src:(p.featured_image||null);
    return im?{img:im,t:p.title,h:(isLocal()?SHOP_ABS+'/products/'+p.handle:shopPath('/products/'+p.handle))}:null;
  }).filter(Boolean);
}
function fetchProducts(handle,limit,cb){
  /* 0) ręczne nadpisanie do testów lokalnych: window.LBQ_IMAGES = ['https://...','https://...'] */
  if(window.LBQ_IMAGES&&window.LBQ_IMAGES.length){
    return cb(window.LBQ_IMAGES.map(function(u,i){return {img:u,t:T('ui.122')+(i+1),h:SHOP_ABS}}));
  }
  var path=handle?('/collections/'+handle+'/products.json?limit='+limit):('/products.json?limit='+limit);
  /* zawsze z labalancia.com — działa tak samo lokalnie, na podglądzie i na sklepie */
  jget(SHOP_ABS+path).then(function(d){
    var list=mapProducts(d);
    if(list.length){cb(list);return}
    /* awaryjnie: ścieżka względna (gdyby domena kiedyś się zmieniła) */
    jget(shopPath(path)).then(function(d2){
      var l2=mapProducts(d2);
      if(!l2.length&&window.console)console.warn('[LBQ] Nie udało się pobrać zdjęć z '+SHOP_ABS+path
        +' — sprawdź, czy kolekcja istnieje i jest opublikowana.');
      cb(l2);
    });
  });
}


/* ═════ EMIT: dwa poziomy zbierania danych ═════
   A) bez zgody  → w pełni anonimowo: brak ID, brak IP po naszej stronie,
                   brak pól tekstowych, brak e-maila. Poza zakresem RODO.
   B) ze zgodą   → dochodzi trwały identyfikator, teksty i sklejanie wizyt.
   Adres odbiorczy ustawia szablon: window.LBQ_ENDPOINT = '...'  */
var ENDPOINT=(typeof window.LBQ_ENDPOINT==='string')?window.LBQ_ENDPOINT:'';
var sent={};

function payload(kind,extra){
  var ans={},free=0;
  asked.forEach(function(k){
    var q=pool[k];if(P.a[q.id]===undefined)return;
    ans[q.id]=P.a[q.id];
    if(P.a[q.id+'_txt'])free++;
  });
  var c=P.ctx||{};
  var d={
    v:'lbq5', kind:kind, ts:new Date().toISOString(),
    path:P.path, etap:P.etap, done:!!P.done,
    answers:ans, answered:asked.length,
    signals:{hot:S.hot,gr:S.gr,churn:S.churn,prob:S.prob,ptak:S.ptak+S.wiz,dr:S.dr,st:S.st},
    calc:P.calc||null,
    seconds:P.t.start?Math.round((Date.now()-P.t.start)/1000):0,
    perQ:P.t.perQ||{},
    meta:{lang:c.jezyk||null,market:c.rynek||null,currency:c.waluta||null,
          device:c.device||null,tz:c.tz||null,
          ref:(function(){try{return c.ref&&c.ref!=='direct'?new URL(c.ref).hostname:c.ref}catch(e){return 'direct'}})(),
          utm_source:c.utm_source||null,utm_medium:c.utm_medium||null,
          utm_campaign:c.utm_campaign||null},
    logged:!!P.customer,
    consent:!!memory,
    freeTextCount:free
  };
  if(memory){                         /* dopiero za zgodą */
    d.id=P.id||null;
    var t={};asked.forEach(function(k){var q=pool[k];
      if(P.a[q.id+'_txt'])t[q.id]=P.a[q.id+'_txt']});
    if(Object.keys(t).length)d.texts=t;
  }
  return Object.assign(d,extra||{});
}

function emit(kind,extra){
  if(!ENDPOINT)return;
  if(sent[kind])return; sent[kind]=1;
  var body=JSON.stringify(payload(kind,extra));
  try{
    if(navigator.sendBeacon){
      navigator.sendBeacon(ENDPOINT,new Blob([body],{type:'text/plain;charset=UTF-8'}));
    } else {
      fetch(ENDPOINT,{method:'POST',mode:'no-cors',keepalive:true,
        headers:{'Content-Type':'text/plain;charset=UTF-8'},body:body}).catch(function(){});
    }
  }catch(e){}
}

/* porzucenie: wysyłamy raz, gdy karta znika i są co najmniej 2 odpowiedzi */
function emitAbandon(){
  if(P.done||asked.length<3||sent.complete)return;
  sent.abandon=0; emit('abandon',{lastQuestion:(pool[asked[asked.length-1]]||{}).id||null});
}
document.addEventListener('visibilitychange',function(){
  if(document.visibilityState==='hidden')emitAbandon();
});
window.addEventListener('pagehide',emitAbandon);

/* ═════ KONTO ═════ */
function detect(cb){
  if(window.LBQ_CUSTOMER&&window.LBQ_CUSTOMER.id){P.customer=window.LBQ_CUSTOMER;return cb()}
  var f=false,t=setTimeout(function(){if(!f){f=true;cb()}},2500);
  try{fetch(shopPath('/account'),{credentials:'same-origin',redirect:'follow'})
    .then(function(r){if(r.url&&r.url.indexOf('/account/login')===-1&&r.status===200)P.customer={id:'session',orders:null}})
    .catch(function(){}).then(function(){if(!f){f=true;clearTimeout(t);cb()}})}
  catch(e){if(!f){f=true;clearTimeout(t);cb()}}
}

/* ═════ PYTANIA ═════ */
var A=function(id){return P.a[id]};
var qtext=function(q){return (typeof q.q==='function')?q.q():q.q};
var has=function(id,v){var x=P.a[id];return !!(x&&x.indexOf&&x.indexOf(v)>-1)};
var BRAMA={id:'brama',path:'*',q:T('brama.q'),hint:T('brama.hint'),
 a:[{v:'prospekt',t:T('brama.o.prospekt'),s:T('brama.s.prospekt')},
    {v:'partner',t:T('brama.o.partner'),s:T('brama.s.partner')},
    {v:'detal',t:T('brama.o.detal')},
    {v:'inne',t:T('brama.o.inne')}]};
var Q=[
{id:'p_staz',path:'prospekt',q:T('p_staz.q'),hint:T('p_staz.hint'),
 a:[{v:'roz',t:T('p_staz.o.roz')},{v:'rok',t:T('p_staz.o.rok')},
    {v:'ponad',t:T('p_staz.o.ponad')},{v:'kanaly',t:T('p_staz.o.kanaly')}]},
{id:'p_kanal',path:'prospekt',
 q:function(){return A('p_staz')==='roz'?T('p_kanal.qAlt'):T('p_kanal.q')},
 hint:T('p_kanal.hint'),
 a:[{v:'butik',t:T('p_kanal.o.butik'),st:2,tag:T('tag.butik')},{v:'online',t:T('p_kanal.o.online'),tag:T('tag.sklep_online')},
    {v:'mp',t:T('p_kanal.o.mp'),dr:2,tag:T('tag.marketplace')},
    {v:'social',t:T('p_kanal.o.social'),dr:2,tag:T('tag.social_selling')},
    {v:'hurt',t:T('p_kanal.o.hurt'),st:3,tag:T('tag.hurt_eksport')},
    {v:'marka',t:T('p_kanal.o.marka'),mk:1,tag:T('tag.własna_marka')},
    {v:'nic',t:T('p_kanal.o.nic'),when:function(){return A('p_staz')==='roz'},tag:T('tag.przed_startem')}]},
{id:'p_rytm',path:'prospekt',when:function(){return A('p_staz')!=='roz'},
 q:T('p_rytm.q'),hint:T('p_rytm.hint'),
 a:[{v:'poj',t:T('p_rytm.o.poj')},{v:'sez',t:T('p_rytm.o.sez')},
    {v:'reg',t:T('p_rytm.o.reg')},{v:'ros',t:T('p_rytm.o.ros'),gr:1}]},
{id:'p_marza',path:'prospekt',when:function(){return A('p_staz')!=='roz'},
 q:T('p_marza.q'),
 hint:T('p_marza.hint'),
 a:[{v:'nie',t:T('p_marza.o.nie'),tag:T('tag.marża_nieliczona')},
    {v:'grubo',t:T('p_marza.o.grubo'),tag:T('tag.marża_szacowana')},
    {v:'tak',t:T('p_marza.o.tak'),tag:T('tag.marża_policzona')}]},
{id:'p_skad',path:'prospekt',multi:true,max:3,when:function(){return A('p_staz')!=='roz'},
 q:T('p_skad.q'),hint:T('p_skad.hint'),
 a:[{v:'ptak',t:T('p_skad.o.ptak'),ptak:1,tag:T('tag.zakupy_w_Ptaku')},
    {v:'plhurt',t:T('p_skad.o.plhurt'),tag:T('tag.hurtownie_PL')},
    {v:'tr',t:T('p_skad.o.tr'),tag:T('tag.import_TR')},
    {v:'cn',t:T('p_skad.o.cn'),tag:T('tag.import_CN')},
    {v:'it',t:T('p_skad.o.it'),tag:T('tag.import_IT')},
    {v:'plprod',t:T('p_skad.o.plprod'),tag:T('tag.producent_PL')},
    {v:'brak',t:T('p_skad.o.brak'),excl:true,tag:T('tag.bez_dostawcy')}]},
{id:'p_bol',path:'prospekt',multi:true,max:3,q:T('p_bol.q'),hint:T('p_bol.hint'),
 a:[{v:'jakosc',t:T('p_bol.o.jakosc'),tag:T('tag.jakość')},
    {v:'rozm',t:T('p_bol.o.rozm'),tag:T('tag.rozmiarówka')},
    {v:'termin',t:T('p_bol.o.termin'),tag:T('tag.terminy')},
    {v:'minimum',t:T('p_bol.o.minimum'),dr:1,tag:T('tag.wysokie_MOQ')},
    {v:'tresci',t:T('p_bol.o.tresci'),tag:T('tag.brak_treści')},
    {v:'zwroty',t:T('p_bol.o.zwroty'),tag:T('tag.zwroty')},
    {v:'kapital',t:T('p_bol.o.kapital'),dr:2,tag:T('tag.kapitał')},
    {v:'nowe',t:T('p_bol.o.nowe'),tag:T('tag.tempo_nowości')},
    {v:'klientki',t:T('p_bol.o.klientki'),tag:T('tag.ruch')}]},
{id:'p_asort',path:'prospekt',multi:true,max:3,
 q:function(){return A('p_staz')==='roz'?T('p_asort.qAlt'):T('p_asort.q')},
 hint:T('p_asort.hint'),
 a:[{v:'sukienki',t:T('p_asort.o.sukienki'),tag:T('tag.sukienki')},{v:'komplety',t:T('p_asort.o.komplety'),tag:T('tag.komplety')},
    {v:'bluzki',t:T('p_asort.o.bluzki'),tag:T('tag.bluzki')},{v:'doly',t:T('p_asort.o.doly'),tag:T('tag.doły')},
    {v:'okrycia',t:T('p_asort.o.okrycia'),tag:T('tag.okrycia')},{v:'nocne',t:T('p_asort.o.nocne'),tag:T('tag.piżamy')},
    {v:'szukam',t:T('p_asort.o.szukam'),excl:true,tag:T('tag.kategoria_otwarta')}]},
{id:'p_rozm',path:'prospekt',multi:true,max:2,when:function(){return A('p_staz')!=='roz'},
 q:T('p_rozm.q'),hint:T('p_rozm.hint'),
 a:[{v:'sm',t:T('p_rozm.o.sm'),tag:T('tag.S_M')},{v:'ml',t:T('p_rozm.o.ml'),tag:T('tag.M_L')},{v:'lxxl',t:T('p_rozm.o.lxxl'),tag:T('tag.L_XXL')},
    {v:'plus',t:T('p_rozm.o.plus'),tag:T('tag.plus_size')},
    {v:'pelny',t:T('p_rozm.o.pelny'),excl:true,tag:T('tag.pełna_rozmiarówka')}]},
{id:'p_cena',path:'prospekt',when:function(){return A('p_staz')!=='roz'},q:T('p_cena.q'),
 hint:T('p_cena.hint'),
 a:[{v:'a',t:T('p_cena.o.a'),tag:T('tag.półka_99_zł')},{v:'b',t:T('p_cena.o.b'),tag:T('tag.półka_100_159')},
    {v:'c',t:T('p_cena.o.c'),tag:T('tag.półka_160_249')},{v:'d',t:T('p_cena.o.d'),tag:T('tag.półka_250_399')},
    {v:'e',t:T('p_cena.o.e'),tag:T('tag.półka_400_')}]},
{id:'p_towar',path:'prospekt',
 q:function(){return A('p_staz')==='roz'?T('p_towar.qAlt'):T('p_towar.q')},
 a:[{v:'zaplecze',t:T('p_towar.o.zaplecze'),st:3,tag:T('tag.zaplecze')},
    {v:'magazyn',t:T('p_towar.o.magazyn'),st:3,gr:1,tag:T('tag.magazyn')},
    {v:'dostawca',t:T('p_towar.o.dostawca'),dr:3,tag:T('tag.bez_magazynu')},
    {v:'nigdzie',t:T('p_towar.o.nigdzie'),when:function(){return A('p_staz')==='roz'||has('p_skad','brak')},tag:T('tag.przed_pierwszym_zakupem')}]},
{id:'p_tech',path:'prospekt',when:function(){var k=A('p_kanal');return k&&k!=='butik'&&k!=='nic'},
 q:T('p_tech.q'),hint:T('p_tech.hint'),
 a:[{v:'shopify',t:T('p_tech.o.shopify'),tag:T('tag.Shopify')},{v:'woo',t:T('p_tech.o.woo'),tag:T('tag.WooCommerce_Shoper')},
    {v:'bl',t:T('p_tech.o.bl'),tag:T('tag.BaseLinker')},{v:'inny',t:T('p_tech.o.inny'),tag:T('tag.inny_system')},
    {v:'brak',t:T('p_tech.o.brak'),tag:T('tag.ręcznie')}]},
{id:'p_budzet',path:'prospekt',q:T('p_budzet.q'),hint:T('p_budzet.hint'),
 a:[{v:'a',t:T('p_budzet.o.a'),tag:T('tag.budżet_2_tys_')},{v:'b',t:T('p_budzet.o.b'),tag:T('tag.budżet_2_5_tys_')},
    {v:'c',t:T('p_budzet.o.c'),tag:T('tag.budżet_5_15_tys_')},{v:'d',t:T('p_budzet.o.d'),gr:1,tag:T('tag.budżet_15_tys_')},
    {v:'drop',t:T('p_budzet.o.drop'),dr:3,tag:T('tag.bez_zakupu_towaru')}]},
{id:'p_kiedy',path:'prospekt',q:T('p_kiedy.q'),
 a:[{v:'teraz',t:T('p_kiedy.o.teraz'),hot:3,tag:T('tag.start_ten_tydzień')},{v:'miesiac',t:T('p_kiedy.o.miesiac'),hot:2,tag:T('tag.start_ten_miesiąc')},
    {v:'sezon',t:T('p_kiedy.o.sezon'),hot:1,tag:T('tag.start_nowy_sezon')},{v:'patrze',t:T('p_kiedy.o.patrze'),hot:0,tag:T('tag.rozgląda_się')}]},
{id:'p_ptak',path:'prospekt',q:T('p_ptak.q'),hint:T('p_ptak.hint'),
 a:[{v:'reg',t:T('p_ptak.o.reg'),ptak:1,tag:T('tag.bywa_w_Ptaku')},{v:'raz',t:T('p_ptak.o.raz'),tag:T('tag.był_raz')},
    {v:'online',t:T('p_ptak.o.online'),tag:T('tag.tylko_online')},{v:'chce',t:T('p_ptak.o.chce'),wiz:1,tag:T('tag.chce_przyjechać')}]},

{id:'m_kiedy',path:'partner',q:T('m_kiedy.q'),
 a:[{v:'nigdy',t:T('m_kiedy.o.nigdy'),s:T('m_kiedy.s.nigdy')},
    {v:'teraz',t:T('m_kiedy.o.teraz'),tag:T('tag.aktywny')},{v:'kwartal',t:T('m_kiedy.o.kwartal'),tag:T('tag.1_3_mies_')},
    {v:'pol',t:T('m_kiedy.o.pol'),churn:1,tag:T('tag.uśpiony_6m_')},{v:'niepam',t:T('m_kiedy.o.niepam'),churn:1,tag:T('tag.uśpiony')}]},
{id:'m_co',path:'partner',when:function(){var v=A('m_kiedy');return v==='pol'||v==='niepam'},
 q:T('m_co.q'),hint:T('m_co.hint'),
 a:[{v:'inny',t:T('m_co.o.inny'),tag:T('tag.odejście_do_konkurencji')},
    {v:'asort',t:T('m_co.o.asort'),tag:T('tag.niedopasowanie_oferty')},
    {v:'problem',t:T('m_co.o.problem'),tag:T('tag.problem_operacyjny')},
    {v:'biznes',t:T('m_co.o.biznes'),tag:T('tag.zmiana_u_klienta')},
    {v:'nic',t:T('m_co.o.nic'),tag:T('tag.naturalna_przerwa')}],free:T('m_co.free')},
{id:'m_udzial',path:'partner',when:function(){var v=A('m_kiedy');return v!=='pol'&&v!=='niepam'},
 q:T('m_udzial.q'),
 a:[{v:'a',t:T('m_udzial.o.a'),tag:T('tag.udział_10_')},{v:'b',t:T('m_udzial.o.b'),tag:T('tag.udział_25_')},
    {v:'c',t:T('m_udzial.o.c'),tag:T('tag.udział_50_')},{v:'d',t:T('m_udzial.o.d'),tag:T('tag.udział_75_')}]},
{id:'m_luka',path:'partner',multi:true,max:3,when:function(){var v=A('m_kiedy');return v!=='pol'&&v!=='niepam'},
 q:T('m_luka.q'),hint:T('m_luka.hint'),
 a:[{v:'duze',t:T('m_luka.o.duze'),tag:T('tag.luka_duże_rozmiary')},{v:'zima',t:T('m_luka.o.zima'),tag:T('tag.luka_okrycia')},
    {v:'wiecz',t:T('m_luka.o.wiecz'),tag:T('tag.luka_wieczorowe')},{v:'basic',t:T('m_luka.o.basic'),tag:T('tag.luka_basic')},
    {v:'dod',t:T('m_luka.o.dod'),tag:T('tag.luka_dodatki')},{v:'tanie',t:T('m_luka.o.tanie'),tag:T('tag.luka_niższa_półka')},
    {v:'drogie',t:T('m_luka.o.drogie'),tag:T('tag.luka_wyższa_półka')},
    {v:'nic',t:T('m_luka.o.nic'),excl:true,tag:T('tag.brak_luki')}],free:T('m_luka.free')},
{id:'m_popraw',path:'partner',multi:true,max:3,when:function(){var v=A('m_kiedy');return v!=='pol'&&v!=='niepam'},
 q:T('m_popraw.q'),hint:T('m_popraw.hint'),
 a:[{v:'stany',t:T('m_popraw.o.stany'),tag:T('tag.popraw_stany')},{v:'nowe',t:T('m_popraw.o.nowe'),tag:T('tag.popraw_nowości')},
    {v:'rozm',t:T('m_popraw.o.rozm'),tag:T('tag.popraw_rozmiary')},{v:'ceny',t:T('m_popraw.o.ceny'),tag:T('tag.popraw_ceny')},
    {v:'wysylka',t:T('m_popraw.o.wysylka'),tag:T('tag.popraw_wysyłka')},{v:'platnosc',t:T('m_popraw.o.platnosc'),tag:T('tag.popraw_płatności')},
    {v:'xml',t:T('m_popraw.o.xml'),tag:T('tag.popraw_XML')},{v:'opiekun',t:T('m_popraw.o.opiekun'),tag:T('tag.popraw_kontakt')}]},
{id:'m_problem',path:'partner',when:function(){var v=A('m_kiedy');return v!=='pol'&&v!=='niepam'},
 q:T('m_problem.q'),
 a:[{v:'nie',t:T('m_problem.o.nie')},{v:'jakosc',t:T('m_problem.o.jakosc'),prob:1,tag:T('tag.problem_jakość')},
    {v:'opozn',t:T('m_problem.o.opozn'),prob:1,tag:T('tag.problem_opóźnienie')},{v:'braki',t:T('m_problem.o.braki'),prob:1,tag:T('tag.problem_braki')},
    {v:'rozlicz',t:T('m_problem.o.rozlicz'),prob:1,tag:T('tag.problem_rozliczenia')}]},
{id:'m_plan',path:'partner',q:T('m_plan.q'),hint:T('m_plan.hint'),
 a:[{v:'rozwoj',t:T('m_plan.o.rozwoj'),gr:1,tag:T('tag.plan_rozwój')},{v:'bez',t:T('m_plan.o.bez'),tag:T('tag.plan_bez_zmian')},
    {v:'ogr',t:T('m_plan.o.ogr'),churn:1,tag:T('tag.plan_ograniczenie')},{v:'kanal',t:T('m_plan.o.kanal'),gr:1,tag:T('tag.plan_nowy_kanał')}]},

{id:'u_blok',path:'uspiony',q:T('u_blok.q'),
 hint:T('u_blok.hint'),
 a:[{v:'brak',t:T('u_blok.o.brak'),tag:T('tag.brak_asortymentu')},
    {v:'ceny',t:T('u_blok.o.ceny'),tag:T('tag.niedopasowana_półka')},
    {v:'jak',t:T('u_blok.o.jak'),tag:T('tag.brak_onboardingu')},
    {v:'sezon',t:T('u_blok.o.sezon'),tag:T('tag.czeka_na_sezon')},
    {v:'porown',t:T('u_blok.o.porown'),tag:T('tag.w_porównaniu')},
    {v:'formal',t:T('u_blok.o.formal'),tag:T('tag.blokada_formalna')}],free:T('u_blok.free')},
{id:'u_co',path:'uspiony',q:T('u_co.q'),
 a:[{v:'probka',t:T('u_co.o.probka'),tag:T('tag.chce_próbki')},
    {v:'rozmowa',t:T('u_co.o.rozmowa'),tag:T('tag.chce_rozmowy')},
    {v:'wizyta',t:T('u_co.o.wizyta'),wiz:1,tag:T('tag.chce_wizyty')},
    {v:'zdjecia',t:T('u_co.o.zdjecia'),tag:T('tag.chce_treści')},
    {v:'nic',t:T('u_co.o.nic'),tag:T('tag.obserwuje')}]},
{id:'u_asort',path:'uspiony',multi:true,max:3,q:T('u_asort.q'),hint:T('u_asort.hint'),
 a:[{v:'sukienki',t:T('u_asort.o.sukienki'),tag:T('tag.sukienki')},{v:'komplety',t:T('u_asort.o.komplety'),tag:T('tag.komplety')},
    {v:'bluzki',t:T('u_asort.o.bluzki'),tag:T('tag.bluzki')},{v:'doly',t:T('u_asort.o.doly'),tag:T('tag.doły')},
    {v:'okrycia',t:T('u_asort.o.okrycia'),tag:T('tag.okrycia')},{v:'nocne',t:T('u_asort.o.nocne'),tag:T('tag.piżamy')}]},

{id:'d_region',path:'detal',q:T('d_region.q'),hint:T('d_region.hint'),
 a:[{v:'lodz',t:T('d_region.o.lodz')},{v:'mazow',t:T('d_region.o.mazow')},{v:'slask',t:T('d_region.o.slask')},
    {v:'wlkp',t:T('d_region.o.wlkp')},{v:'malop',t:T('d_region.o.malop')},{v:'inne',t:T('d_region.o.inne')}]},
{id:'i_co',path:'inne',q:T('i_co.q'),
 a:[{v:'uslugi',t:T('i_co.o.uslugi')},{v:'logist',t:T('i_co.o.logist')},
    {v:'produkcja',t:T('i_co.o.produkcja')},{v:'inne2',t:T('i_co.o.inne2')}]}
];

/* ═════ SILNIK ═════ */
var cursor=-1,asked=[],pool=[],S={};
function buildPool(){pool=[BRAMA].concat(Q.filter(function(q){return q.path===P.path}))}
function earlyExit(q){
  if(P.path!=='prospekt')return false;
  if(q.id==='p_tech'&&A('p_kanal')==='butik')return true;
  if(q.id==='p_budzet'&&A('p_towar')==='dostawca'&&has('p_bol','kapital'))return true;
  if(q.id==='p_ptak'&&A('p_kiedy')==='patrze')return true;
  return false;
}
function nextIdx(from){for(var k=from;k<pool.length;k++){var q=pool[k];
  if(q.when&&!q.when())continue;if(earlyExit(q))continue;return k}return -1}
function visCount(){var n=0;for(var k=0;k<pool.length;k++){var q=pool[k];
  if(q.when&&!q.when())continue;if(earlyExit(q))continue;n++}return n}
function known(){var k=[];if(P.customer){k.push('konto B2B');
  if(P.customer.orders!=null)k.push(P.customer.orders+T('ui.123'))}
  if(P.ctx.rynek)k.push('rynek '+P.ctx.rynek);return k}
function stageCalc(){
  var base={roz:0,rok:1,ponad:2,kanaly:3}[A('p_staz')];
  if(base==null)return null;
  var floor=0,cap=4,r=A('p_rytm'),m=A('p_marza'),k=A('p_kanal');
  /* rytm: nieregularność ogranicza, powtarzalność podnosi */
  if(r==='poj')cap=Math.min(cap,1);
  else if(r==='sez')cap=Math.min(cap,2);
  else if(r==='reg'||r==='ros')floor=Math.max(floor,3);
  /* marża: brak wiedzy zamyka drogę wyżej, policzona podnosi podłogę */
  if(m==='nie')cap=Math.min(cap,2);
  else if(m==='tak')floor=Math.max(floor,2);
  /* ograniczenia zawsze wygrywają z podłogami */
  var e=Math.min(cap,Math.max(floor,base));
  if((k==='marka'||k==='hurt')&&e>=2)e=4;
  return Math.max(0,Math.min(4,e));
}
function recompute(){
  S={gr:0,dr:0,st:0,hot:0,churn:0,prob:0,ptak:0,wiz:0,mk:0};P.tags=[];
  asked.forEach(function(k){var q=pool[k],val=P.a[q.id];if(val===undefined)return;
    var vals=q.multi?val:[val];
    q.a.forEach(function(o){if(vals.indexOf(o.v)===-1)return;
      ['gr','dr','st','hot','churn','prob','ptak','wiz','mk'].forEach(function(f){if(o[f])S[f]+=o[f]});
      if(o.tag)P.tags.push(o.tag)})});
  P.etap=(P.path==='prospekt')?stageCalc():null;
}
function pad(n){return n<10?'0'+n:''+n}
function swap(html,after){
  var cur=stage.firstElementChild;
  if(!cur){stage.innerHTML=html;if(after)after();return}
  cur.classList.add('out');
  setTimeout(function(){stage.innerHTML=html;if(after)after()},155);
}
function mapHtml(){
  if(P.path!=='prospekt'||P.etap==null||asked.length<2)return '';
  var N=[T('etap0.n'),T('etap1.n'),T('etap2.n'),T('etap3.n'),T('etap4.n')],h='<div class="map">';
  for(var i=0;i<5;i++){
    var cl=i===P.etap?'now':(i<P.etap?'done':'');
    h+='<div class="mcell '+cl+'"><span class="mono">E'+i+'</span><span class="lb">'+N[i]+'</span></div>';
  }
  return h+'</div>';
}
function render(){
  var qi=nextIdx(cursor+1);
  if(qi===-1){result();return}
  var q=pool[qi],total=visCount(),kn=known().length,
      doneN=asked.length+kn,totalN=total+kn,pct=(doneN/totalN)*100;

  var h='<div class="fade"><div class="thead"><div class="prog">'
   +'<span class="c"><b>'+pad(doneN+1)+'</b> / '+pad(totalN)+'</span>'
   +'<span class="tr"><i style="width:'+pct+'%"></i></span></div>'
   +'<span class="mono">'+(P.path?P.path:'start')+'</span></div>'
   +mapHtml()
   +(kn?'<p class="known">'+T('ui.264')+' '+known().join(' · ')+'</p>':'')
   +'<p class="q">'+qtext(q)+'</p>'+(q.hint?'<p class="qh">'+q.hint+'</p>':'')+'<div class="opts">';
  q.a.filter(function(o){return !o.when||o.when()}).forEach(function(o,i){
    h+='<button class="opt'+(q.multi?' multi':'')+'" data-v="'+o.v+'"><span class="k">'
     +(q.multi?'□':pad(i+1))+'</span><span class="t">'+o.t
     +(o.s?'<span class="s">'+o.s+'</span>':'')+'</span></button>'});
  h+='</div>';
  if(q.free)h+='<textarea class="free" id="lbqFree" placeholder="'+q.free+'"></textarea>';
  h+='<div class="nav"><button class="back" id="lbqBack"'+(asked.length===0?' hidden':'')+'>← Wstecz</button>';
  if(q.multi)h+='<button class="btn btn-1" id="lbqNext" disabled>Dalej <span class="ar">→</span></button>';
  h+='</div></div>';

  swap(h,function(){
    P.t.perQ[q.id+'_in']=Date.now();
    if(q.multi){
      var pick=[],nx=document.getElementById('lbqNext');
      stage.querySelectorAll('.opt').forEach(function(b){b.onclick=function(){
        var v=b.dataset.v,p=pick.indexOf(v);
        if(p>-1){pick.splice(p,1);b.classList.remove('sel');b.querySelector('.k').textContent='□'}
        else{
          var o=q.a.filter(function(x){return x.v===v})[0];
          function clear(fn){stage.querySelectorAll('.opt').forEach(function(z){
            if(fn(z.dataset.v)){var j=pick.indexOf(z.dataset.v);if(j>-1)pick.splice(j,1);
              z.classList.remove('sel');z.querySelector('.k').textContent='□'}})}
          if(o&&o.excl)clear(function(){return true});
          else clear(function(vv){var oo=q.a.filter(function(x){return x.v===vv})[0];return oo&&oo.excl});
          if(q.max&&pick.length>=q.max)return;
          pick.push(v);b.classList.add('sel');b.querySelector('.k').textContent='■'}
        nx.disabled=pick.length===0}});
      nx.onclick=function(){
        if(q.free){var f=document.getElementById('lbqFree');
          if(f&&f.value.trim())P.a[q.id+'_txt']=f.value.trim().slice(0,500)}
        answer(qi,pick.slice())};
    } else {
      stage.querySelectorAll('.opt').forEach(function(b){b.onclick=function(){
        if(q.free){var f=document.getElementById('lbqFree');
          if(f&&f.value.trim())P.a[q.id+'_txt']=f.value.trim().slice(0,500)}
        answer(qi,b.dataset.v)}});
    }
    var bk=document.getElementById('lbqBack');if(bk)bk.onclick=undo;
  });
}
function answer(qi,val){
  var q=pool[qi];P.a[q.id]=val;
  var t0=P.t.perQ[q.id+'_in'];if(t0)P.t.perQ[q.id]=Math.round((Date.now()-t0)/1000);
  /* konto bez pierwszego zamówienia → ścieżka uśpiona */
  if(q.id==='m_kiedy'&&val==='nigdy'){
    delete P.a['m_kiedy'];P.path='uspiony';buildPool();asked=[0];cursor=0;recompute();save();render();return}
  if(q.id==='brama'){P.path=(val==='partner'&&P.customer&&P.customer.orders===0)?'uspiony':val;
    buildPool();asked=[0];cursor=0;recompute();save();render();return}
  asked.push(qi);cursor=qi;recompute();save();
  track('lbq_answer',{lbq_path:P.path,lbq_question:q.id,lbq_value:String(val)});
  render();
}
function undo(){
  var qi=asked.pop();if(qi===undefined)return;
  var q=pool[qi];delete P.a[q.id];delete P.a[q.id+'_txt'];cursor=qi-1;
  if(q.id==='brama'){P.path=null;buildPool();asked=[];cursor=-1}
  recompute();save();render();
}

/* ═════ TREŚĆ ═════ */
var ETAP=[
{n:T('etap0.n'),pod:T('etap0.pod'),sig:T('etap0.sig'),pri:T('etap0.pri'),blad:T('etap0.blad'),
 h:T('etap0.h'),
 diag:T('etap0.diag'),
 skup:[T('etap0.skup.0'),T('etap0.skup.1'),T('etap0.skup.2')],
 nie:[T('etap0.nie.0'),T('etap0.nie.1'),T('etap0.nie.2')],
 m30:[T('etap0.m30.0'),T('etap0.m30.1')],
 m90:[T('etap0.m90.0'),T('etap0.m90.1')],
 my:T('etap0.my')},
{n:T('etap1.n'),pod:T('etap1.pod'),sig:T('etap1.sig'),pri:T('etap1.pri'),blad:T('etap1.blad'),
 h:T('etap1.h'),
 diag:T('etap1.diag'),
 skup:[T('etap1.skup.0'),T('etap1.skup.1'),T('etap1.skup.2')],
 nie:[T('etap1.nie.0'),T('etap1.nie.1'),T('etap1.nie.2')],
 m30:[T('etap1.m30.0'),T('etap1.m30.1')],
 m90:[T('etap1.m90.0'),T('etap1.m90.1')],
 my:T('etap1.my')},
{n:T('etap2.n'),pod:T('etap2.pod'),sig:T('etap2.sig'),pri:T('etap2.pri'),blad:T('etap2.blad'),
 h:T('etap2.h'),
 diag:T('etap2.diag'),
 skup:[T('etap2.skup.0'),T('etap2.skup.1'),T('etap2.skup.2')],
 nie:[T('etap2.nie.0'),T('etap2.nie.1')],
 m30:[T('etap2.m30.0'),T('etap2.m30.1')],
 m90:[T('etap2.m90.0'),T('etap2.m90.1')],
 my:T('etap2.my')},
{n:T('etap3.n'),pod:T('etap3.pod'),sig:T('etap3.sig'),pri:T('etap3.pri'),blad:T('etap3.blad'),
 h:T('etap3.h'),
 diag:T('etap3.diag'),
 skup:[T('etap3.skup.0'),T('etap3.skup.1'),T('etap3.skup.2')],
 nie:[T('etap3.nie.0'),T('etap3.nie.1')],
 m30:[T('etap3.m30.0'),T('etap3.m30.1')],
 m90:[T('etap3.m90.0'),T('etap3.m90.1')],
 my:T('etap3.my')},
{n:T('etap4.n'),pod:T('etap4.pod'),sig:T('etap4.sig'),pri:T('etap4.pri'),blad:T('etap4.blad'),
 h:T('etap4.h'),
 diag:T('etap4.diag'),
 skup:[T('etap4.skup.0'),T('etap4.skup.1'),T('etap4.skup.2')],
 nie:[T('etap4.nie.0'),T('etap4.nie.1')],
 m30:[T('etap4.m30.0'),T('etap4.m30.1')],
 m90:[T('etap4.m90.0'),T('etap4.m90.1')],
 my:T('etap4.my')}
];
function model(){
  if(P.etap===0)return {n:T('ui.125'),
    t:T('ui.126')};
  var d=S.dr-S.st;
  if(d>=2)return {n:T('ui.127'),
    t:T('ui.128')};
  if(d<=-2)return {n:T('ui.129'),
    t:T('ui.130')};
  return {n:'Model mieszany — bestsellery u siebie, reszta od nas',
    t:T('ui.131')};
}
function integracja(){
  var t=A('p_tech');if(!t)return '';
  if(t==='shopify')return T('ui.132');
  if(t==='woo')return T('ui.133');
  if(t==='bl')return T('ui.134');
  if(t==='inny')return T('ui.135');
  return T('ui.136');
}
function polka(){
  var c=A('p_cena'),out=[];
  if(c==='a')out.push(T('ui.137'));
  else if(c==='b')out.push(T('ui.138'));
  else if(c==='c')out.push(T('ui.139'));
  else if(c==='d')out.push(T('ui.140'));
  else if(c==='e')out.push(T('ui.141'));
  if(has('p_rozm','plus')||has('p_rozm','lxxl'))out.push(T('ui.142'));
  else if(has('p_rozm','pelny'))out.push(T('ui.143'));
  return out;
}
function nastepny(){
  var b=A('p_budzet'),k=A('p_kiedy'),o=[];
  if(k==='teraz'||k==='miesiac'){
    if(b==='a'||b==='drop')o.push(T('ui.144'));
    else if(b==='d')o.push(T('ui.145'));
    else o.push(T('ui.146'));
  } else if(k==='sezon')o.push(T('ui.147'));
  else o.push(T('ui.148'));
  if(S.wiz)o.push(T('ui.149'));
  else if(S.ptak)o.push(T('ui.150'));
  return o;
}
function argument(){
  var o=[];
  if(has('p_skad','cn')&&has('p_bol','zwroty'))o.push(T('ui.151'));
  if(has('p_skad','cn')&&has('p_bol','termin'))o.push(T('ui.152'));
  if(has('p_skad','tr')&&has('p_bol','rozm'))o.push(T('ui.153'));
  if(has('p_skad','plhurt')&&has('p_bol','nowe'))o.push(T('ui.154'));
  if(has('p_bol','minimum')&&has('p_bol','kapital'))o.push(T('ui.155'));
  if(has('p_bol','tresci'))o.push(T('ui.156'));
  if(has('p_bol','jakosc'))o.push(T('ui.157'));
  if(has('p_bol','klientki'))o.push(T('ui.158'));
  return o;
}
var PASMA=[[T('pasma0.v'),T('pasma0.t')],[T('pasma1.v'),T('pasma1.t')],[T('pasma2.v'),T('pasma2.t')],[T('pasma3.v'),T('pasma3.t')],[T('pasma4.v'),T('pasma4.t')]];
var COL={sukienki:'sukienki-hurtownia-odziezy-damskiej',komplety:'komplety-hurtownia-odziezy-damskiej',
 bluzki:'bluzki-hurtownia-odziezy-damskiej',doly:'spodniczki-spodnie-hurtownia-odziezy-damskiej',
 okrycia:'bluzy-kurtki-hurtownia-odziezy-damskiej',nocne:'pizamy-damskie-la-balancia-hurtownia-odziezy-damskiej'};
var L={katalog:[T('link.katalog'),'/collections/nowosci-hurtownia-odziezy-damskiej'],
 sztuki:[T('link.sztuki'),'/pages/hurtownia-odziezy-damskiej-online-na-sztuki'],
 drop:[T('link.drop'),'/pages/dropshipping-i-wspolpraca-biznesowa'],
 xml:[T('link.xml'),'/pages/labalancia-xml-feed-b2b-zacznij-sprzedawac-natychmiast'],
 lojal:[T('link.lojal'),'/pages/program-lojalnosciowy-dla-butikow'],
 marka:[T('link.marka'),'/pages/brand-labalancia'],
 prod:[T('link.prod'),'/pages/polska-produkcja-odziez-damska'],
 hurt:[T('link.hurt'),'/pages/hurtownia-odziezy-damskiej'],
 detal:[T('link.detal'),'/pages/punkty-detaliczne-labalancia']};
function lnk(e){return e===0?[L.drop,L.detal,L.hurt]:e===1?[L.sztuki,L.drop,L.katalog]:
  e===2?[L.sztuki,L.xml,L.katalog]:e===3?[L.hurt,L.xml,L.lojal]:[L.marka,L.prod,L.hurt]}

/* ═════ ROZDZIAŁY ETAPÓW (warstwa treści, bez szkła) ═════ */
function buildChapters(){
  /* Treść rozdziałów jest już w HTML (dla wyszukiwarek).
     Tutaj dokładamy tylko zachowanie: pojawianie się i podświetlanie w nawigacji. */
  var box=document.getElementById('lbqChapters'); if(!box)return;
  var nav=document.getElementById('lbqChNav');
  if('IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(en){en.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('in');io2.unobserve(e.target)}})},
      {threshold:.15,rootMargin:'0px 0px -60px 0px'});
    box.querySelectorAll('.rv').forEach(function(el){io2.observe(el)});
    if(nav){
      var spy=new IntersectionObserver(function(en){en.forEach(function(e){
        if(e.isIntersecting){var id=e.target.id.replace('ch','');
          nav.querySelectorAll('a').forEach(function(a2){a2.classList.toggle('on',a2.dataset.ch===id)})}})},
        {threshold:.5});
      box.querySelectorAll('.ch').forEach(function(el){spy.observe(el)});
    }
  } else box.querySelectorAll('.rv').forEach(function(el){el.classList.add('in')});
}

/* ═════ ZDJĘCIA W WARSTWIE TREŚCI ═════ */
function fillMedia(){
  fetchProducts('nowosci-hurtownia-odziezy-damskiej',24,function(list){
    if(list.length>=6){paint(list);return}
    fetchProducts('hurtownia-odziezy-damskiej',24,function(l2){
      if(l2.length>=6){paint(l2);return}
      fetchProducts(null,24,function(l3){paint(l3.length?l3:list)});
    });
  });
  function pick(l,i){return l[i%l.length]}
  function bg(el,url){if(!el)return;el.style.backgroundImage='url("'+url+'")';el.classList.add('ready')}
  function paint(list){
    if(!list||!list.length){fallback();return}
    bg(document.getElementById('lbqHeroBg'),pick(list,0).img);
    var fg=document.getElementById('lbqHeroFg');
    if(fg){bg(fg.firstElementChild,pick(list,1).img);fg.classList.add('ready')}
    bg(document.getElementById('lbqManImg'),pick(list,2).img);
    bg(document.getElementById('lbqBandBg'),pick(list,3).img);
    var ib=document.getElementById('lbqIntBand');
    if(ib)[].forEach.call(ib.children,function(c,i){bg(c,pick(list,4+i).img)});
    document.querySelectorAll('#lbq .scbg i').forEach(function(el,i){bg(el,pick(list,8+i*3).img)});
    document.querySelectorAll('#lbq .ch-img').forEach(function(el,i){bg(el,pick(list,11+i).img)});
  }
  /* zapasowa tekstura, gdy katalog jest niedostępny — układ nigdy nie jest pusty */
  function fallback(){
    var G=['linear-gradient(140deg,#E9E4DC,#D8CFC4 60%,#C8BCAE)',
           'linear-gradient(150deg,#EDE7E4,#DCC9C8 55%,#C6A9AC)',
           'linear-gradient(135deg,#E4E4DE,#CFCFC6 62%,#B9B9AE)',
           'linear-gradient(160deg,#EFE9E2,#D6CBBD 58%,#BFB2A2)',
           'linear-gradient(145deg,#E8E2E2,#D3C2C4 60%,#B9A3A6)'];
    function fg(el,i){if(!el)return;el.style.backgroundImage=G[i%G.length];el.classList.add('ready')}
    fg(document.getElementById('lbqHeroBg'),0);
    var h=document.getElementById('lbqHeroFg');
    if(h){fg(h.firstElementChild,1);h.classList.add('ready')}
    fg(document.getElementById('lbqManImg'),2);
    fg(document.getElementById('lbqBandBg'),3);
    var ib=document.getElementById('lbqIntBand');
    if(ib)[].forEach.call(ib.children,function(c,i){fg(c,i)});
    document.querySelectorAll('#lbq .scbg i').forEach(function(el,i){fg(el,i+1)});
    document.querySelectorAll('#lbq .ch-img').forEach(function(el,i){fg(el,i)});
  }
}
/* ═════ WYNIK ═════ */
function parts(){
  /* Wynik rozbity na osobne pola formularza — mail jest wtedy czytelny */
  var P1={},l=[];
  asked.forEach(function(k){var q=pool[k],v=P.a[q.id];if(v===undefined)return;
    var lab=(q.multi?v:[v]).map(function(x){var o=q.a.filter(function(y){return y.v===x})[0];return o?o.t:x}).join(', ');
    l.push(qtext(q)+'\n   → '+lab);
    if(P.a[q.id+'_txt'])l.push('   ↳ „'+P.a[q.id+'_txt']+'"')});

  P1.etap=(P.path==='prospekt'&&P.etap!=null)
    ? (P.etap+' — '+ETAP[P.etap].n) : '—';
  P1.sciezka={prospekt:'Prospekt (nowy)',partner:'Partner (ma konto)',
    uspiony:'Uśpiony (konto bez zamówień)',detal:'Detal (osoba prywatna)',
    inne:'Inne (agencja/oferta)'}[P.path]||P.path;

  var got={3:'bardzo wysoka — start w tym tygodniu',2:'wysoka — start w tym miesiącu',
           1:'średnia — przed sezonem',0:'niska — rozgląda się'}[S.hot];
  var sig=[];
  sig.push('gotowość: '+(got||'—'));
  if(S.gr)sig.push('sygnał wzrostu');
  if(S.churn)sig.push('RYZYKO ODEJŚCIA');
  if(S.prob)sig.push('ZGŁOSZONY PROBLEM');
  if(S.ptak)sig.push('bywa w Ptaku');
  if(S.wiz)sig.push('chce przyjechać do showroomu');
  if(P.customer)sig.push('zalogowany na koncie B2B');
  P1.sygnaly=sig.join(' · ');

  P1.kalkulator=P.calc||'nie liczył';

  var hs=hist();
  var uniq=hs.map(function(z){return z.e}).filter(function(v,i,a){return i===0||a[i-1]!==v});
  P1.historia = uniq.length>1 ? uniq.map(function(e){return 'etap '+e}).join(' → ')
              : (hs.length>1 ? hs.length+' wizyty, bez zmiany etapu' : 'pierwsza wizyta');

  P1.odpowiedzi=l.join('\n');

  var c=P.ctx,x=[];
  if(c.jezyk)x.push('język: '+c.jezyk);
  if(c.rynek)x.push('rynek: '+c.rynek);
  if(c.device)x.push('urządzenie: '+c.device);
  if(c.utm_source)x.push('źródło: '+c.utm_source+(c.utm_campaign?' / '+c.utm_campaign:''));
  else if(c.ref&&c.ref!=='direct')x.push('skąd: '+c.ref);
  x.push('czas testu: '+P.t.total+' s');
  if(P.id)x.push('id: '+P.id);
  P1.kontekst=x.join(' · ');
  return P1;
}
function summary(){
  var p=parts();
  return 'ETAP: '+p.etap+'\nŚCIEŻKA: '+p.sciezka+'\nSYGNAŁY: '+p.sygnaly
    +'\nHISTORIA: '+p.historia+'\nKALKULATOR: '+p.kalkulator
    +'\n\nODPOWIEDZI:\n'+p.odpowiedzi+'\n\nKONTEKST: '+p.kontekst;
}
function leadCta(){
  return '<div class="lead-cta"><p><b>'+T('ui.070')+'</b> '+T('ui.159')
   +'<a class="btn btn-1" href="#lbqForm" data-toform="1">'+T('ui.100').replace(/\?$/,'')+' <span class="ar">↓</span></a></div>';
}
function acc(t,b,open){return '<details class="acc"'+(open?' open':'')+'><summary>'+t+'</summary><div class="bd">'+b+'</div></details>'}
function ul(a,c){return '<ul class="pl '+(c||'')+'">'+a.map(function(i){return '<li>'+i+'</li>'}).join('')+'</ul>'}

function mount(h){rstage.innerHTML=h;go('result')}
function result(){
  P.done=true;P.t.total=P.t.start?Math.round((Date.now()-P.t.start)/1000):0;pushHist();save();
  var h='<div class="fade">';

  if(P.path==='detal'){
    var RG={lodz:T('ui.003'),
      mazow:T('ui.004'),
      slask:T('ui.005'),
      wlkp:T('ui.006'),
      malop:T('ui.007'),
      inne:T('ui.008')};
    h+='<div class="vtop"><span class="mono">Dla Ciebie</span><h2>'+T('ui.071')+'</h2>'
     +'<p class="lede">'+T('ui.113')+''
     +(RG[A('d_region')]||'')+'</p>'
     +'<div class="cta-row"><a class="btn btn-1" href="'+L.detal[1]+'">'+T('ui.072')+'<span class="ar">→</span></a></div></div>'
     +'<div style="margin-top:30px" id="lbqProd"></div></div>';
    mount(h);loadProducts();track('lbq_complete',{lbq_path:'detal'});return;
  }
  if(P.path==='inne'){
    var IC={uslugi:T('ui.009'),
      logist:T('ui.010'),
      produkcja:T('ui.011'),
      inne2:''};
    h+='<div class="vtop"><h2>'+T('ui.073')+'</h2><p class="lede">'
     +(IC[A('i_co')]||'')+' Oferty przyjmujemy pod adresem '
     +'<a href="mailto:kontakt@labalancia.com">kontakt@labalancia.com</a>'+T('ui.114')+''
     +T('ui.160');
    mount(h);track('lbq_complete',{lbq_path:'inne'});return;
  }

  if(P.path==='prospekt'){
    var E=ETAP[P.etap],arg=argument(),hs=hist();
    h+='<div class="vtop"><span class="mono">'+E.pod+' · diagnoza</span><h2>'+E.n+'</h2>'
     +'<p class="lede">'+E.h+'</p>'
     +'<div class="chips">'+P.tags.map(function(t){return '<span class="chip">'+t+'</span>'}).join('')+'</div></div>'+leadCta();
    if(hs.length>1&&hs[hs.length-2].e!==P.etap){var pr=hs[hs.length-2].e;
      h+='<div class="note" style="margin-top:22px">'+T('ui.115')+''+pr+'. '
       +(P.etap>pr?T('ui.012'):T('ui.013'))+'</div>'}
    h+='<div class="duo"><div class="pane"><span class="mono">'+T('ui.074')+'</span>'+ul(E.skup)+'</div>'
     +'<div class="pane warn"><span class="mono">'+T('ui.075')+'</span>'+ul(E.nie,'no')+'</div></div>';
    h+=acc(T('ui.014'),'<p>'+E.diag+'</p>',true);
    if(arg.length)h+=acc('W Twoim konkretnym przypadku',arg.map(function(a){return '<p>'+a+'</p>'}).join(''),true);
    var M=model();
    h+=acc(T('ui.015')+M.n,'<p>'+M.t+'</p>');
    var pk=polka();
    if(pk.length)h+=acc(T('ui.016'),pk.map(function(a){return '<p>'+a+'</p>'}).join(''));
    var ig=integracja();
    if(ig)h+=acc('Droga integracji','<p>'+ig+'</p>');
    var ns=nastepny();
    if(ns.length)h+=acc(T('ui.017'),ns.map(function(a){return '<p>'+a+'</p>'}).join(''),true);
    h+=acc(T('ui.018'),'<ol class="steps">'+E.m30.map(function(m){return '<li>'+m+'</li>'}).join('')+'</ol>')
     +acc(T('ui.019'),'<ol class="steps">'+E.m90.map(function(m){return '<li>'+m+'</li>'}).join('')+'</ol>')
     +acc('Zdrowe pasma — orientacyjnie','<div class="bands">'+PASMA.map(function(b){
        return '<div class="band"><span>'+b[1]+'</span><b>'+b[0]+'</b></div>'}).join('')
        +'</div><p class="xs" style="margin-top:12px">'+T('ui.076')+'</p>')
     +acc(T('ui.020'),'<div class="note">'+E.my+'</div><div class="links" style="margin-top:16px">'
        +lnk(P.etap).map(function(x){return '<a href="'+shopPath(x[1])+'">'+x[0]+'</a>'}).join('')+'</div>');
    h+='<div style="margin-top:34px"><h3>'+T('ui.077')+'</h3>'
     +'<p class="xs" style="margin:8px 0 18px">'+T('ui.078')+'</p>'
     +'<div id="lbqProd"></div></div>'+kalk('r');
  }

  if(P.path==='partner'){
    var ch=S.churn>0;
    h+='<div class="vtop"><span class="mono">'+T('ui.079')+'</span>'
     +'<h2>'+(ch?T('ui.021'):T('ui.022'))+'</h2>'
     +'<p class="lede">'+(ch?T('ui.023')
       :T('ui.024'))+'</p>'
     +'<div class="chips">'+P.tags.map(function(t){return '<span class="chip">'+t+'</span>'}).join('')+'</div></div>'+leadCta();
    var mc=A('m_co');
    if(mc){var MC={inny:T('ui.025'),
      asort:T('ui.026'),
      problem:T('ui.027'),
      biznes:T('ui.028'),
      nic:T('ui.029')};
      h+=acc('Co z tym robimy','<p>'+MC[mc]+'</p>'
       +(P.a['m_co_txt']?'<p class="sm">'+T('ui.116')+''+P.a['m_co_txt']+'"</p>':''),true)}
    if(S.prob)h+=acc(T('ui.030'),T('ui.161'),true);
    if(A('m_luka')&&!has('m_luka','nic'))h+=acc(T('ui.031'),'<p>'+T('ui.080')+'</p>',true);
    var PR={stany:T('ui.032'),nowe:T('ui.033'),
      rozm:T('ui.034'),ceny:'poziom cen',wysylka:T('ui.035'),
      platnosc:T('ui.036'),xml:T('ui.037'),opiekun:'kontakt z opiekunem'};
    var pop=A('m_popraw')||[],ud=A('m_udzial'),pl=A('m_plan');
    if(pop.length){
      h+=acc('Co bierzemy na siebie','<p>'+T('ui.117')+''+pop.map(function(x){return PR[x]||x}).join(', ')
       +T('ui.038')
       +T('ui.162'),true);
    }
    if(ud){
      var UD={a:T('ui.039'),
        b:T('ui.040'),
        c:T('ui.041'),
        d:T('ui.042')};
      h+=acc(T('ui.043'),'<p>'+UD[ud]+'</p>');
    }
    if(pl==='ogr')h+=acc(T('ui.044'),'<p>'+T('ui.081')+'</p>',true);
    else if(pl==='kanal')h+=acc(T('ui.045'),'<p>'+T('ui.082')+'</p>');
    h+=acc('Co dalej','<ol class="steps"><li>'+T('ui.083')+'</li>'
      +'<li>'+T('ui.084')+'</li>'
      +'<li>'+T('ui.085')+'</li></ol>'
      +'<div class="links" style="margin-top:16px">'+[L.lojal,L.katalog,L.xml].map(function(x){return '<a href="'+shopPath(x[1])+'">'+x[0]+'</a>'}).join('')+'</div>',true);
    h+='<div style="margin-top:32px"><h3>Nowe w katalogu</h3><div style="margin-top:16px" id="lbqProd"></div></div>';
  }

  if(P.path==='uspiony'){
    var u=A('u_blok'),kr=T('ui.046');
    if(u==='brak')kr=T('ui.047');
    if(u==='ceny')kr=T('ui.048');
    if(u==='jak')kr=T('ui.049');
    if(u==='sezon')kr=T('ui.050');
    if(u==='porown')kr=T('ui.051');
    if(u==='formal')kr=T('ui.052');
    h+='<div class="vtop"><span class="mono">Odblokujmy to</span><h2>'+T('ui.086')+'</h2>'
     +'<p class="lede">'+T('ui.087')+'</p>'
     +'<div class="chips">'+P.tags.map(function(t){return '<span class="chip">'+t+'</span>'}).join('')+'</div></div>'+leadCta()
     +'<div class="note" style="margin-top:22px">'+kr+'</div>'
     +(function(){var c=A('u_co'),M={probka:T('ui.053'),
        rozmowa:T('ui.054'),
        wizyta:T('ui.055'),
        zdjecia:T('ui.056'),
        nic:T('ui.057')};
        return M[c]?'<div class="note" style="margin-top:12px">'+M[c]+'</div>':''})()
     +'<div style="margin-top:32px"><h3>'+T('ui.088')+'</h3><div style="margin-top:16px" id="lbqProd"></div></div>';
  }

  h+=form()+'</div>';
  mount(h);
  loadProducts();bindKalk('r');bindForm();bindPush();
  track('lbq_complete',{lbq_path:P.path,lbq_etap:P.etap,lbq_seconds:P.t.total});
  emit('complete');
}

function loadProducts(){
  var box=document.getElementById('lbqProd');if(!box)return;
  box.innerHTML='<div class="pgrid">'+Array(5).join('<div class="psk"></div>')+'</div>';
  var sel=A('p_asort')||A('u_asort')||[],hs=[];
  sel.forEach(function(v){if(COL[v])hs.push(COL[v])});
  if(!hs.length)hs=['nowosci-hurtownia-odziezy-damskiej'];
  var out=[],pend=Math.min(hs.length,3),painted=false;
  function paint(){
    if(painted)return;painted=true;
    if(!out.length){box.innerHTML='<p class="sm">'+T('ui.089')+'<a href="'+(isLocal()?SHOP_ABS:'')+L.katalog[1]+'">'+L.katalog[0]+'</a></p>';return}
    box.innerHTML='<div class="pgrid">'+out.slice(0,4).map(function(p){
      return '<a href="'+p.h+'"><img src="'+p.img+'" alt="'+p.t.replace(/"/g,'')+'" loading="lazy"><div class="nm">'+p.t+'</div></a>'
    }).join('')+'</div><div class="links" style="margin-top:14px"><a href="'+L.katalog[1]+'">'+T('ui.090')+'</a></div>';
  }
  hs.slice(0,3).forEach(function(hn){fetchProducts(hn,4,function(list){
    out=out.concat(list);if(--pend<=0)paint()})});
  setTimeout(paint,4000);
}

/* ═════ KALKULATOR ═════ */
function kalk(px,head){
  var t=head!==false;
  return (t?'<div style="margin-top:38px"><h3>'+T('ui.091')+'</h3>'
   +'<p class="xs" style="margin:8px 0 20px">'+T('ui.092')+'</p>':'<div>')
   +'<div class="calc"><div class="cin">'
   +'<div class="crow"><label for="'+px+'c1">Cena zakupu <b>netto</b></label><input type="number" id="'+px+'c1" value="45" min="0"></div>'
   +'<div class="crow"><label for="'+px+'c2">'+T('ui.093')+'<b>brutto</b></label><input type="number" id="'+px+'c2" value="139" min="0"></div>'
   +'<div class="crow"><label for="'+px+'c3">Stawka VAT (%)</label><input type="number" id="'+px+'c3" value="23" min="0" max="27"></div>'
   +'<div class="crow"><label for="'+px+'c4">'+T('ui.094')+'</label><input type="number" id="'+px+'c4" value="14" min="0"></div>'
   +'<div class="crow"><label for="'+px+'c5">Pakowanie i dodatki</label><input type="number" id="'+px+'c5" value="3" min="0"></div>'
   +'<div class="crow"><label for="'+px+'c6">'+T('ui.095')+'</label><input type="number" id="'+px+'c6" value="0" min="0" max="40"></div>'
   +'<div class="crow"><label for="'+px+'c7">'+T('ui.096')+'</label><input type="number" id="'+px+'c7" value="5000" min="1"></div>'
   +'<div class="srow"><div class="tp"><span>Zwroty</span><b id="'+px+'cZ">20%</b></div>'
   +'<input type="range" id="'+px+'s1" min="0" max="60" value="20"></div>'
   +'<div class="srow"><div class="tp"><span>'+T('ui.097')+'</span><b id="'+px+'cR">85%</b></div>'
   +'<input type="range" id="'+px+'s2" min="0" max="100" value="85"></div>'
   +'</div><div class="glass cout" id="'+px+'cOut"></div></div></div>';
}
function anim(el,to,sfx,dec){
  var from=parseFloat(el.dataset.v||'0'),t0=null;el.dataset.v=to;
  function fr(ts){if(!t0)t0=ts;var k=Math.min((ts-t0)/420,1),e=1-Math.pow(1-k,3);
    el.textContent=(from+(to-from)*e).toFixed(dec)+sfx;if(k<1)requestAnimationFrame(fr)}
  requestAnimationFrame(fr);
}
function bindKalk(px){
  var out=document.getElementById(px+'cOut');if(!out)return;
  var touched=false;   /* zapis dopiero, gdy ktoś faktycznie ruszy pole */
  var ids=['c1','c2','c3','c4','c5','c6','c7','s1','s2'].map(function(i){return px+i});
  var z=document.getElementById(px+'cZ'),rr=document.getElementById(px+'cR');
  out.innerHTML='<div class="cr"><span>'+T('ui.098')+'</span><b id="'+px+'o0">0</b></div>'
   +'<div class="cr"><span>Zysk na sztuce, po zwrotach</span><b id="'+px+'o1">0</b></div>'
   +'<div class="cr"><span>'+T('ui.099')+'</span><b id="'+px+'o2">0</b></div>'
   +'<div class="cr"><span>Przebicie ceny zakupu</span><b id="'+px+'o3">0</b></div>'
   +'<div class="cr" style="border-bottom:none"><span>Sztuk do celu</span><b id="'+px+'o4">0</b></div>'
   +'<div class="cv" id="'+px+'o5"></div>';
  function calc(){
    var v=ids.map(function(i){return parseFloat(document.getElementById(i).value)||0});
    var zak=v[0],brutto=v[1],vat=Math.max(0,v[2]),wy=v[3],pk=v[4],prow=Math.max(0,v[5]),cel=v[6]||1,
        zw=Math.min(Math.max(v[7],0),90)/100, res=Math.min(Math.max(v[8],0),100)/100;
    z.textContent=Math.round(v[7])+'%'; rr.textContent=Math.round(v[8])+'%';
    /* 1) sprowadzamy sprzedaż do netto — inaczej porównujemy różne wielkości */
    var netSale=brutto/(1+vat/100);
    /* 2) kontrybucja na jednej udanej sprzedaży */
    var prowKw=netSale*prow/100;
    var kontr=netSale-zak-wy-pk-prowKw;
    /* 3) koszt jednego zwrotu: wysyłka w obie strony, opakowanie, część towaru nie do odsprzedaży */
    var kosztZwrotu=wy*2+pk+(1-res)*zak;
    var netto=kontr*(1-zw)-zw*kosztZwrotu;
    var marza=netSale>0?(netto/netSale)*100:0;
    var prz=zak>0?netSale/zak:0;
    var szt=netto>0?Math.ceil(cel/netto):0;
    var ok=marza>=25&&prz>=2;
    anim(document.getElementById(px+'o0'),netSale,' zł',2);
    anim(document.getElementById(px+'o1'),netto,' zł',2);
    anim(document.getElementById(px+'o2'),marza,'%',1);
    anim(document.getElementById(px+'o3'),prz,'×',2);
    anim(document.getElementById(px+'o4'),szt,'',0);
    var o5=document.getElementById(px+'o5');o5.className='cv '+(ok?'ok':'no');
    o5.textContent=netto<=0
      ?T('ui.058')
      :ok?T('ui.059')
      :(prz<2?T('ui.060')
             :T('ui.061'));
    if(touched){
      P.calc='zakup '+zak+T('ui.062')+brutto+' brutto (VAT '+vat+'%) = '+netSale.toFixed(2)
        +' netto | zwroty '+Math.round(v[7])+T('ui.063')+Math.round(v[8])+'%, prowizja '+prow
        +'% | zysk '+netto.toFixed(2)+T('ui.163')+marza.toFixed(1)+'%), przebicie '+prz.toFixed(2)+'×';
      save();
    }
  }
  ids.forEach(function(i){var el=document.getElementById(i);
    el.oninput=function(){touched=true;calc()};
    el.onchange=function(){touched=true;calc()}});
  calc();   /* pierwsze przeliczenie tylko dla podglądu — nic nie zapisuje */
}

/* ═════ FORMULARZ ═════ */
function form(){
  var zal=!P.customer&&P.path!=='detal';
  return '<div style="margin-top:40px;padding-top:32px;border-top:1px solid var(--line2)" class="fm" id="lbqForm">'
   +'<h3>'+T('ui.100')+'</h3>'
   +'<p class="sm" style="margin:8px 0 22px">'+T('ui.118')+''
   +(zal?T('ui.064'):'')+'</p>'
   +'<form method="post" action="'+shopPath('/contact')+'#lbqForm" accept-charset="UTF-8" id="lbqC">'
   +'<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">'
   +'<input type="hidden" name="contact[1. Etap]" id="lbqF1">'
   +'<input type="hidden" name="contact[2. Ścieżka]" id="lbqF2">'
   +'<input type="hidden" name="contact[3. Sygnały]" id="lbqF3">'
   +'<input type="hidden" name="contact[4. Kalkulator]" id="lbqF4">'
   +'<input type="hidden" name="contact[5. Historia]" id="lbqF5">'
   +'<input type="hidden" name="contact[9. Kontekst]" id="lbqF9">'
   +'<div class="hp"><input type="text" name="lbq_hp" tabindex="-1" autocomplete="off" id="lbqHp" aria-hidden="true"></div>'
   +'<div class="fgrid"><div class="fld"><label class="fl" for="lbqE">E-mail *</label><input type="email" id="lbqE" name="contact[email]" required autocomplete="email"></div>'
   +'<div class="fld"><label class="fl" for="lbqF">Nazwa firmy</label><input type="text" id="lbqF" name="contact[Firma]" autocomplete="organization"></div></div>'
   +'<div class="fgrid"><div class="fld"><label class="fl" for="lbqN">NIP / VAT-EU</label><input type="text" id="lbqN" name="contact[NIP]"></div>'
   +'<div class="fld"><label class="fl" for="lbqT">Telefon</label><input type="tel" id="lbqT" name="contact[Telefon]" autocomplete="tel"></div></div>'
   +'<div class="fld"><label class="fl" for="lbqW">Sklep lub profil</label><input type="text" id="lbqW" name="contact[Sklep]" placeholder="np. twojsklep.pl albo @twojprofil"></div>'
   +T('ui.164')
   +'<div class="cons"><input type="checkbox" id="lbqOk" name="contact[Zgoda]" value="tak" required>'
   +'<label for="lbqOk" style="margin:0">'+T('ui.119')+''
   +'<a href="'+shopPath('/policies/privacy-policy')+'" target="_blank" rel="noopener">'+T('ui.065')+'</a></label></div>'
   +'<div class="cta-row" style="margin-top:0"><button type="submit" class="btn btn-1">'+T('ui.101')+'<span class="ar">→</span></button>'
   +(zal?'<a class="btn btn-2" href="'+shopPath('/account/register')+'">'+T('ui.102')+'</a>':'')+'</div>'
   +'<details class="data"><summary>'+T('ui.103')+'</summary><div class="in" id="lbqPv"></div></details>'
   +'</form></div>';
}
function bindPush(){
  var bar=document.getElementById('lbqPush'),form=document.getElementById('lbqForm');
  document.querySelectorAll('#lbq [data-toform]').forEach(function(a){
    a.onclick=function(e){
      e.preventDefault();
      var f=document.getElementById('lbqForm');if(!f)return;
      f.scrollIntoView({behavior:'smooth',block:'start'});
      f.classList.remove('pulse');void f.offsetWidth;f.classList.add('pulse');
      var em=document.getElementById('lbqE');
      if(em)setTimeout(function(){try{em.focus({preventScroll:true})}catch(_){em.focus()}},650);
    };
  });
  if(!bar||!form)return;
  bar.hidden=false;
  if('IntersectionObserver' in window){
    var io3=new IntersectionObserver(function(en){en.forEach(function(e){
      bar.classList.toggle('off',e.isIntersecting)})},{threshold:.18});
    io3.observe(form);
  }
}
function bindForm(){
  var f=document.getElementById('lbqC');if(!f)return;
  function fill(){
    var p=parts();
    var set=function(id,v){var el=document.getElementById(id);if(el)el.value=v||''};
    set('lbqF1',p.etap); set('lbqF2',p.sciezka); set('lbqF3',p.sygnaly);
    set('lbqF4',p.kalkulator); set('lbqF5',p.historia); set('lbqF9',p.kontekst);
    var pv=document.getElementById('lbqPv');
    if(pv)pv.innerHTML=summary().replace(/\n/g,'<br>');
    return p;
  }
  fill();
  var d=f.querySelector('details');if(d)d.addEventListener('toggle',fill);
  f.addEventListener('submit',function(e){
    if(document.getElementById('lbqHp').value!==''){e.preventDefault();return}
    var p=fill(),b=document.getElementById('lbqB');
    var own=b.value.trim();
    b.value=(own?own+'\n\n':'')+'— — — ODPOWIEDZI Z TESTU — — —\n'+p.odpowiedzi;
    track('lbq_lead',{lbq_path:P.path,lbq_etap:P.etap});
    sent.lead=0;emit('lead',{formSubmitted:true});
  });
}

/* ═════ START ═════ */
function begin(fresh){
  if(fresh){P.a={};P.path=null;P.etap=null;P.calc=null;asked=[];cursor=-1;P.done=false}
  P.t.start=Date.now();P.ctx=ctxRead();P.id=P.id||ckG(IDKEY);
  buildPool();recompute();save();track('lbq_start',{lbq_returning:!!P.id});render();
}
function intro(prev){
  var res=prev&&prev.a&&Object.keys(prev.a).length&&!prev.done,hs=hist(),last=hs.length?hs[hs.length-1]:null;
  var h='<div class="fade">';
  if(res)h+='<div class="note" style="margin-bottom:22px">'+T('ui.120')+''
    +'<button class="back" id="lbqRes" style="margin-left:8px">'+T('ui.104')+'</button> '
    +'<button class="back" id="lbqFr" style="margin-left:8px">Od nowa</button></div>';
  else if(last)h+='<div class="note" style="margin-bottom:22px">'+T('ui.105')+'<b>etap '+last.e+'</b>'+T('ui.106')+'</div>';
  if(P.customer)h+='<div class="note" style="margin-bottom:22px">'+T('ui.107')+'</div>';
  h+='<span class="mono">'+T('ui.265')+'</span><p class="q" style="margin-top:14px">'+T('ui.108')+'</p>'
   +'<p class="qh">'+T('ui.109')+'</p>'
   +'<div class="cta-row" style="margin-top:8px"><button class="btn btn-1" id="lbqGo">'+T('ui.216')+' <span class="ar">→</span></button></div></div>';
  stage.innerHTML=h;
  document.getElementById('lbqGo').onclick=function(){begin(true)};
  if(res){
    document.getElementById('lbqRes').onclick=function(){
      P=Object.assign(P,prev);buildPool();asked=[];cursor=-1;
      for(var k=0;k<pool.length;k++){if(P.a[pool[k].id]!==undefined){asked.push(k);cursor=k}}
      begin(false)};
    document.getElementById('lbqFr').onclick=function(){lsD(KEY);begin(true)};
  }
}
document.getElementById('lbqRestart').onclick=function(){
  lsD(KEY);P.a={};P.tags=[];P.path=null;P.etap=null;P.calc=null;P.done=false;
  asked=[];cursor=-1;buildPool();recompute();go('quiz');begin(true);
};

bindHome();
document.querySelectorAll('#lbq [data-calc]').forEach(function(el){
  el.onclick=function(ev){ev.preventDefault();openCalc()};
});
document.querySelectorAll('#lbq [data-start]').forEach(function(el){
  el.onclick=function(ev){
    ev.preventDefault();
    go('quiz');
    var prev=load(),hs=hist();
    if((prev&&prev.a&&Object.keys(prev.a).length&&!prev.done)||(hs.length)||P.customer) intro(prev);
    else begin(true);
  };
});

/* Szablon: statyczne teksty z data-t */
(function(){
  var VOID={BR:1,HR:1,IMG:1,INPUT:1,META:1,LINK:1};
  document.querySelectorAll('#lbq [data-t]').forEach(function(el){
    try{ if(VOID[el.tagName])return;
         var v=T(el.getAttribute('data-t')); if(v)el.innerHTML=v; }catch(e){}
  });
})();
buildChapters();fillMedia();
initConsent();
if(location.search.indexOf('contact_posted=true')>-1){
  rstage.innerHTML='<div class="fade"><div class="vtop"><span class="mono">'+T('ui.079')+'</span>'
   +'<h2 style="margin:14px 0 14px">'+T('ui.110')+'</h2>'
   +'<p class="lede">'+T('ui.111')+' '+T('ui.165')+'</p></div>'
   +'<div class="ctas"><a class="btn btn-1" href="'+shopPath(L.katalog[1])+'">'+T('ui.166')+' <span class="ar">→</span></a>'
   +'<a class="btn btn-2" href="'+shopPath('/account/register')+'">'+T('ui.102')+'</a>'
   +'<a class="btn btn-2" href="#" data-calc="1">'+T('ui.091')+'</a></div>'
   +'<div class="rule"></div><h3>'+T('ui.077')+'</h3><div style="margin-top:16px" id="lbqProd"></div></div>';
  loadProducts();
  document.querySelectorAll('#lbq [data-calc]').forEach(function(el){
    el.onclick=function(ev){ev.preventDefault();openCalc()}});
  go('result',false);lsD(KEY);
} else {
  detect(function(){
    if(P.customer&&P.customer.orders===0)P.path='uspiony';
    P.ctx=ctxRead();buildPool();
    try{history.replaceState({v:'intro'},'',location.pathname+location.search)}catch(e){}
    if(location.search.indexOf('kalkulator=')>-1){openCalc()}
    else if(location.search.indexOf('krok=')>-1){go('quiz',false);intro(load())}
  });
}
})();